import { render, staticRenderFns } from "./UserBank.vue?vue&type=template&id=22f27307&"
import script from "./UserBank.vue?vue&type=script&lang=js&"
export * from "./UserBank.vue?vue&type=script&lang=js&"
import style0 from "./UserBank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports